export default {"src":"/_next/static/media/automated-and-manual-assessments-firm.1f820646.svg","height":274,"width":216,"blurWidth":0,"blurHeight":0};